const IS_FLEX =
  typeof window !== "undefined" &&
  window.origin.includes("integration.project4.com");
const IS_PROD =
  typeof window !== "undefined" && window.origin.includes("johnlewis.com");

type Config = {
  basketBFFBaseUrl: string;
  socialProofApi: string;
  prodcatEndpoint: string;
  prodcatApiKey: string;
};

const localConfig: Config = {
  basketBFFBaseUrl: "http://localhost:3010/proxy/basket-ui",
  socialProofApi:
    "http://localhost:3010/proxy/product-badging/api/v1/social-proof-messaging",
  prodcatEndpoint:
    (typeof process !== "undefined" &&
      process.env.PRODUCT_CATALOGUE_ENDPOINT) ||
    "http://localhost:3010/proxy/catalogue/graphql",
  // deepcode ignore HardcodedNonCryptoSecret
  prodcatApiKey: "PCXN_k_fQfwNkId96LAObkPBU4ZOO0oInk",
};
const flexConfig: Config = {
  basketBFFBaseUrl: "https://api.integration.project4.com/basket-ui",
  socialProofApi:
    "https://api.integration.project4.com/product-badging/api/v1/social-proof-messaging",
  prodcatEndpoint: "https://api.integration.project4.com/catalogue/graphql",
  // deepcode ignore HardcodedNonCryptoSecret
  prodcatApiKey: "PCXN_k_fQfwNkId96LAObkPBU4ZOO0oInk",
};
const prodConfig: Config = {
  basketBFFBaseUrl: "https://api.johnlewis.com/basket-ui",
  socialProofApi:
    "https://api.johnlewis.com/product-badging/api/v1/social-proof-messaging",
  prodcatEndpoint: "https://api.johnlewis.com/catalogue/graphql",
  // deepcode ignore HardcodedNonCryptoSecret
  prodcatApiKey: "WE DONT HAVE THIS YET",
};

const config = IS_PROD ? prodConfig : IS_FLEX ? flexConfig : localConfig;

export default config;
